import { Component, OnInit } from '@angular/core';
import { ListModel } from '@app/common/models/list.model';
import { PageableList } from '@app/models/pageable.list';
import { PageableListService } from '@app/common/services/pageable.list.service';
import { ProjectSubjectModel } from '@app/ps/models/project-subject.model';
import { LesseeEditComponent } from '@app/ps/components/lessee-edit/lessee-edit.component';
import { DialogService } from '@app/common/services/dialog.service';

@Component({
  selector: 'lessee-list',
  templateUrl: './lessee-list.component.html',
})
export class LesseeListComponent implements OnInit {

  list: ListModel<ProjectSubjectModel>;
  pageableList: PageableList;

  private defaultFilter = {
    filters: {
      searchText: { values: [{ id: '' }]},
    }
  };

  constructor(
    private pageableListService: PageableListService,
    private dialogService: DialogService,
  ) {
    this.onCreate = this.onCreate.bind(this);
  }

  ngOnInit() {
    this.pageableList = this.pageableListService.get(
      'lessees',
      this.defaultFilter,
      'lesseesFilter'
    );
    this.list = this.pageableList.list;
    this.pageableList.load();
  }

  uiOnParamsChanged(changedParams, transition) {
    this.pageableList && this.pageableList.uiOnParamsChanged(changedParams, transition);
  }

  onCreate() {
    const dialog = this.dialogService.open(LesseeEditComponent, { data: {} });
    const sub = dialog.afterClosed.subscribe((res: ProjectSubjectModel) => {
      if (res) {
        this.pageableList.fetchResults();
      }
      sub.unsubscribe();
    });
  }
}
